import { useEffect, useState } from "react";

export const useOfflineToast = () => {
  const [showToast, setShowToast] = useState(false);
  const [wasOnline, setWasOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setWasOnline(true);
      setShowToast(false);
    };

    const handleOffline = () => {
      setWasOnline(false);
      setShowToast(true);
    };

    // Vérifier l'état initial
    if (!navigator.onLine) {
      setShowToast(true);
    }

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return {
    showToast,
    setShowToast,
  };
};
